import React from "react";
import { ArrowRight } from "lucide-react";
import PremiumBadge from "./PremiumBadge";
import { useI18n } from "../../i18n/I18nContext";

const ToolCard = ({ tool, onAction }) => {
  const { t } = useI18n();
  return (
  <div className="rounded-2xl border border-slate-200 p-6 bg-white hover:border-[#0a6ed1] transition-colors">
    <div className="flex items-center justify-between">
      <h3 className="font-display font-700 text-lg text-[#0a2540]">{tool.name}</h3>
      {tool.premium ? (
        <PremiumBadge />
      ) : (
        <span className="text-[10px] font-700 uppercase tracking-wider text-[#0a6ed1]">{t("free")}</span>
      )}
    </div>
    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{tool.desc}</p>
    <button
      onClick={() => onAction(tool)}
      className="mt-5 inline-flex items-center gap-1.5 text-sm font-600 text-[#0a2540] hover:text-[#0a6ed1] transition-colors"
    >
      {tool.premium ? t("unlockTool") : t("openTool")} <ArrowRight className="w-4 h-4 text-[#0a6ed1]" />
    </button>
  </div>
  );
};

export default ToolCard;
